import { createElement } from 'react';
import { a as __rest, _ as __assign } from '../../tslib.es6-76e42af7.js';
import { G as CmsFloatingTicker$1 } from '../../index.esm-a3b5eb23.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var CmsFloatingTicker = function CmsFloatingTicker(_a) {
  var props = __rest(_a, ["iconBrand"]);
  return /*#__PURE__*/createElement(CmsFloatingTicker$1, __assign({
    iconBrand: "plst-ec-"
  }, props));
};
CmsFloatingTicker.displayName = 'CmsFloatingTicker';

export { CmsFloatingTicker };
